import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  Chip,
  Fade,
  Divider,
  IconButton,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from "@mui/material";
import {
  School,
  Email,
  Phone,
  LocationOn,
  Gavel,
  Security,
  Policy,
  Facebook,
  Instagram,
  YouTube,
  WhatsApp,
  LinkedIn
} from '@mui/icons-material';
import TelegramIcon from '@mui/icons-material/Telegram';
import { useNavigate, Link } from 'react-router-dom';
import Network from "./network/Network";
import instId from "./network/instituteId";

// Add keyframes for animations
const globalStyles = `
  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 0.1; }
    50% { opacity: 0.3; }
  }
`;

// Inject global styles
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = globalStyles;
  document.head.appendChild(style);
}

const Footer = () => {
  const navigate = useNavigate();
  const [contactUsModal, setContactUsModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [coursesList, setCoursesList] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await Network.fetchCourses(instId);
        if (response?.data) {
          const filterCourses = response.data.filter(item => item.isActive === true);
          setCoursesList(filterCourses);
        }
      } catch (error) {
        console.error("Failed to fetch courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const handleAboutUs = () => {
    navigate('/about-us');
  }

  const handleTermsAndCondition = () => {
    navigate('/terms-condtion');
  }

  const handleCaInterCourse = (item) => {
    const value = coursesList.find(course => course.title === item);
    if (value) {
      navigate('/course-content', { state: { data: value } });
    } else {
      console.error("Course not found");
    }
  }

  const handleContactUs = () => {
    setContactUsModal(true)
  }

  const courseData = [
    { name: "CA Inter", onClick: () => handleCaInterCourse("CA Inter") },
    { name: "CA Final", onClick: () => handleCaInterCourse("CA Final") },
    { name: "CA Foundation", onClick: () => handleCaInterCourse("CA Foundation") },
    { name: "Audit & Ethics" }
  ];

  const subjectData = [
    "Taxation Test Series",
    "Law Test Series",
    "Direct Tax (DT)",
    "Indirect Tax (IDT)",
    "Accounts Test Series",
    "FM & SM Test Series",
    "Cost & Management"
  ];

  const quickLinks = [
    { name: "About Us", icon: <School />, onClick: handleAboutUs },
    { name: "Contact Us", icon: <Email />, onClick: handleContactUs },
    { name: "Refund Policy", icon: <Policy /> },
    { name: "Privacy Policy", icon: <Security /> },
    { name: "Terms & Conditions", icon: <Gavel />, onClick: handleTermsAndCondition }
  ];

  const socialLinks = [
    {
      name: "Facebook",
      icon: <Facebook />,
      url: "https://www.facebook.com/people/FAST-Education/100092834923160/?mibextid=2JQ9oc",
      color: "#1877f2"
    },
    {
      name: "Instagram",
      icon: <Instagram />,
      url: "https://www.instagram.com/vsmartexamprep/",
      color: "#e4405f"
    },
    {
      name: "YouTube",
      icon: <YouTube />,
      url: "https://www.youtube.com/channel/UCmtPrBlbO2REG6I_jxzkBOg",
      color: "#ff0000"
    },
    {
      name: "WhatsApp",
      icon: <WhatsApp />,
      url: "https://api.whatsapp.com/send/?phone=7796898989&text=Hi+Team%2C+is+there+any+related+service+available+%3F&type=phone_number&app_absent=0",
      color: "#25d366"
    },
    {
      name: "LinkedIn",
      icon: <LinkedIn />,
      url: "https://www.linkedin.com/company/fasteducation/",
      color: "#0077b5"
    },
    {
      name: "Telegram",
      icon: <TelegramIcon />,
      url: "https://t.me/vsmartexamprep",
      color: "#0088cc"
    }
  ];

  return (
    <div>
      <Box
        id="contact"
        sx={{
          position: 'relative',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.1) 0%, transparent 50%)',
            pointerEvents: 'none',
          }
        }}
      >
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
          <Fade in={isVisible} timeout={800}>
            <Box sx={{ py: { xs: 3, md: 4 } }}>
              {/* Main Content */}
              <Grid container spacing={3}>
                {/* Test Series Section */}
                <Grid item xs={12} lg={5}>
                  <Box sx={{ mb: 3 }}>
                    {/* CA Courses */}
                    <Card
                      sx={{
                        mb: 2.5,
                        p: 2.5,
                        borderRadius: '16px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          color: '#e2e8f0',
                          fontWeight: 600,
                          mb: 2,
                          fontSize: { xs: '1.1rem', md: '1.25rem' }
                        }}
                      >
                        CA Programs
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                        {courseData.map((course, index) => (
                          <Chip
                            key={index}
                            label={course.name}
                            onClick={course.onClick}
                            sx={{
                              background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                              color: 'white',
                              fontWeight: 500,
                              fontSize: { xs: '14px', md: '14px' },
                              cursor: course.onClick ? 'pointer' : 'default',
                              transition: 'all 0.3s ease',
                              '&:hover': course.onClick ? {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 20px rgba(59, 130, 246, 0.4)',
                              } : {}
                            }}
                          />
                        ))}
                      </Box>
                    </Card>

                    {/* Subject Areas */}
                    <Card
                      sx={{
                        p: 2.5,
                        borderRadius: '16px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        backdropFilter: 'blur(20px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          color: '#e2e8f0',
                          fontWeight: 600,
                          mb: 2,
                          fontSize: { xs: '1.1rem', md: '1.25rem' }
                        }}
                      >
                        Subject Specializations
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                        {subjectData.map((subject, index) => (
                          <Chip
                            key={index}
                            label={subject}
                            sx={{
                              background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                              color: 'white',
                              fontWeight: 500,
                              fontSize: { xs: '14px', md: '14px' },
                            }}
                          />
                        ))}
                      </Box>
                    </Card>
                  </Box>

                  {/* Contact Information */}
                  <Card
                    sx={{
                      p: 2.5,
                      borderRadius: '16px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(20px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#e2e8f0',
                        fontWeight: 600,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: { xs: '14px', md: '14px' }
                      }}
                    >
                      <Phone sx={{ mr: 2, color: '#10b981' }} />
                      Need Help?
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Phone sx={{ mr: 1, color: '#3b82f6', fontSize: '1.2rem' }} />
                        <Typography sx={{ color: '#cbd5e1', fontSize: { xs: '14px', md: '14px' } }}>
                          +91 7796898989
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Email sx={{ mr: 1, color: '#3b82f6', fontSize: '1.2rem' }} />
                        <Typography sx={{ color: '#cbd5e1', fontSize: { xs: '14px', md: '14px' } }}>
                          examprep@vsmartacademy.com
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>

                {/* Quick Links Section */}
                <Grid item xs={12} md={4} lg={3}>
                  <Card
                    sx={{
                      p: 2.5,
                      borderRadius: '16px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(20px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                      height: 'fit-content'
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        mb: 2.5,
                        fontSize: { xs: '1.2rem', md: '1.3rem' },
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <Gavel sx={{ mr: 2, color: '#8b5cf6' }} />
                      Quick Links
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      {quickLinks.map((link, index) => (
                        <Box
                          key={index}
                          onClick={link.onClick}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1.5,
                            borderRadius: '12px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            cursor: link.onClick ? 'pointer' : 'default',
                            transition: 'all 0.3s ease',
                            '&:hover': link.onClick ? {
                              background: 'rgba(255, 255, 255, 0.1)',
                              transform: 'translateX(4px)',
                            } : {}
                          }}
                        >
                          <Box sx={{ color: '#3b82f6', mr: 2 }}>
                            {link.icon}
                          </Box>
                          <Typography
                            sx={{
                              color: '#e2e8f0',
                              fontSize: { xs: '14px', md: '14px' },
                              fontWeight: 500
                            }}
                          >
                            {link.name}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Card>
                </Grid>

                {/* Office & Social Links Section */}
                <Grid item xs={12} md={8} lg={4}>
                  {/* Office Information */}
                  <Card
                    sx={{
                      mb: 2.5,
                      p: 2.5,
                      borderRadius: '16px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(20px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { xs: '1.2rem', md: '1.3rem' },
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <LocationOn sx={{ mr: 2, color: '#f59e0b' }} />
                      Office Address
                    </Typography>

                    <Box sx={{ pl: 4 }}>
                      <Typography sx={{ color: '#cbd5e1', fontSize: { xs: '14px', md: '14px' }, mb: 0.5 }}>
                        Office # 62, 2nd Floor, Kumar
                      </Typography>
                      <Typography sx={{ color: '#cbd5e1', fontSize: { xs: '14px', md: '14px' }, mb: 0.5 }}>
                        Prestige Point, Bajirao Rd,
                      </Typography>
                      <Typography sx={{ color: '#cbd5e1', fontSize: { xs: '14px', md: '14px' } }}>
                        Shukrawar Peth, Pune – 411 002
                      </Typography>
                    </Box>
                  </Card>

                  {/* Social Media Links */}
                  <Card
                    sx={{
                      p: 2.5,
                      borderRadius: '16px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(20px)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        mb: 2.5,
                        fontSize: { xs: '1.2rem', md: '1.3rem' }
                      }}
                    >
                      Connect With Us
                    </Typography>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                      {socialLinks.map((social, index) => (
                        <IconButton
                          key={index}
                          href={social.url}
                          target="_blank"
                          rel="noreferrer"
                          sx={{
                            background: `linear-gradient(135deg, ${social.color}20 0%, ${social.color}40 100%)`,
                            color: social.color,
                            border: `1px solid ${social.color}30`,
                            backdropFilter: 'blur(10px)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              background: social.color,
                              color: 'white',
                              transform: 'translateY(-4px)',
                              boxShadow: `0 8px 25px ${social.color}40`,
                            }
                          }}
                        >
                          {social.icon}
                        </IconButton>
                      ))}
                    </Box>
                  </Card>
                </Grid>
              </Grid>

              {/* Copyright Section */}
              {/* <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.2)' }} /> */}

              <Box sx={{ textAlign: 'center', mt:3 }}>
                <Typography
                  sx={{
                    color: '#94a3b8',
                    fontSize: { xs: '1.5rem', md: '1.5rem' },
                    fontWeight: 500
                  }}
                >
                  © Copyright {new Date().getFullYear()} Vsmart ExamPrep. All rights reserved.
                </Typography>
              </Box>
            </Box>
          </Fade>
        </Container>
      </Box>

      <Dialog
        open={contactUsModal}
        onClose={() => setContactUsModal(false)}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '24px',
            background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
              backgroundSize: '200% 200%',
              animation: 'gradientShift 3s ease infinite'
            }
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(8px)'
          }
        }}
        PaperProps={{
          sx: {
            margin: { xs: 2, sm: 4 },
            maxHeight: { xs: 'calc(100vh - 32px)', sm: 'calc(100vh - 64px)' }
          }
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            p: { xs: 2, sm: 3 },
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              right: 0,
              width: '100px',
              height: '100px',
              background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)',
              transform: 'translate(30px, -30px)'
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '12px',
                  p: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Email sx={{ fontSize: { xs: '1.5rem', sm: '1.8rem' } }} />
              </Box>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: '700',
                    fontSize: { xs: '1.25rem', sm: '1.5rem' },
                    mb: 0.5,
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  Contact Us
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    opacity: 0.9,
                    fontSize: { xs: '0.85rem', sm: '0.9rem' }
                  }}
                >
                  We'd love to hear from you
                </Typography>
              </Box>
            </Box>
            <IconButton
              onClick={() => setContactUsModal(false)}
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  transform: 'rotate(90deg)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              ✕
            </IconButton>
          </Box>
        </Box>

        <DialogContent sx={{ padding: 0, position: 'relative' }}>
          {/* Loading overlay */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(45deg, #f8fafc 25%, transparent 25%, transparent 75%, #f8fafc 75%, #f8fafc), linear-gradient(45deg, #f8fafc 25%, transparent 25%, transparent 75%, #f8fafc 75%, #f8fafc)',
              backgroundSize: '20px 20px',
              backgroundPosition: '0 0, 10px 10px',
              zIndex: 1,
              opacity: 0,
              animation: 'pulse 2s ease-in-out infinite',
              pointerEvents: 'none'
            }}
          />

          <Grid container sx={{ minHeight: { xs: '500px', sm: '600px' } }}>
            <Grid
              item
              xs={12}
              sx={{
                position: 'relative',
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%)',
              }}
            >
              <iframe
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "500px",
                  border: "none",
                  borderRadius: '0 0 24px 24px',
                  background: 'white'
                }}
                src={`https://forms.classiolabs.com/?instituteid=${instId}`}
                onLoad={(e) => {
                  // Hide loading animation when iframe loads
                  const loadingOverlay = e.target.parentElement.querySelector('[style*="animation: pulse"]');
                  if (loadingOverlay) {
                    loadingOverlay.style.opacity = '0';
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{
            p: { xs: 2, sm: 3 },
            background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.8) 100%)',
            borderTop: '1px solid rgba(226, 232, 240, 0.5)',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Phone sx={{ color: '#3b82f6', fontSize: '1.2rem' }} />
            <Typography sx={{ color: '#64748b', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
              Need immediate help? Call us at +91 7796898989
            </Typography>
          </Box>

          <Button
            onClick={() => setContactUsModal(false)}
            variant="outlined"
            sx={{
              borderRadius: '12px',
              borderColor: '#e2e8f0',
              color: '#64748b',
              fontWeight: '600',
              px: { xs: 3, sm: 4 },
              py: 1,
              textTransform: 'none',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              minWidth: { xs: '100%', sm: 'auto' },
              '&:hover': {
                borderColor: '#cbd5e1',
                background: 'rgba(248, 250, 252, 0.8)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      
      <Box
        sx={{
          py: 2,
          textAlign: 'center',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <Typography
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.9rem'
          }}
        >
          Tech partner{' '}
          <Link
            to="https://www.classiolabs.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#ffc107', fontWeight: '600', textDecoration: 'none' }}
            className="hover:underline"
          >
            Classio Labs
          </Link>
        </Typography>
      </Box>
    </div>
  );
};

export { Footer };
export default Footer;
